<template>
    <div class="page bg-gray page-flex">
        <backTitleBar></backTitleBar>
        <div class="page-state">
            <van-tabs v-model="tabActive" swipeable :swipe-threshold="5" :line-width="'.6rem'" @click="tabClick">
                <van-tab :title="item.shopZone.zoneName" :name="$index" v-for="(item,$index) in tabList"
                         :key="$index"></van-tab>
            </van-tabs>
        </div>
        <div class="page-list pd-025">
<!--            <div class="cargo-item click" :class="item.isUse == 1?'active':''" v-for="(item,$index) in data" :key="$index" @click="doEvent(item)">-->
<!--                <div class="fs-32 text-center" :class="item.isUse == 1?'color-org':'color-main'">货道{{item.wayCode}}-{{item.isUse == '1'?'已存':'空'}}</div>-->
<!--                <div class="btn" v-if="item.isUse != 1">-->
<!--                    <div class="opc"></div>-->
<!--                    <div class="opc-in">开门</div>-->
<!--                </div>-->
<!--                <div class="btn" v-else>查看关联</div>-->
<!--            </div>-->
            <div class="fs-32 color-333 font-bold pt-25" v-if="noUsedWayList.length != 0">可寄存</div>
            <div class="list" v-if="noUsedWayList.length != 0">
                <div class="cargo-item click" v-for="(item,$index) in noUsedWayList" :key="$index" @click="doEvent(item)">
                    <div class="fs-32 color-666 text-center">货道{{item.wayCode}}</div>
                    <div class="btn">开门</div>
                </div>
            </div>
            <div class="fs-32 color-333 font-bold pt-25" v-if="usedWayList.length != 0">已寄存</div>
            <div class="list" v-if="usedWayList.length != 0">
                <div class="cargo-item active click" v-for="(item,$index) in usedWayList" :key="$index" @click="doEvent(item)">
                    <div class="fs-32 color-666 text-center">货道{{item.wayCode}}</div>
                    <div class="btn">查看关联</div>
                </div>
            </div>
        </div>

        <orderList ref="orderList" :org-id="orgId" :way-id="wayId" :org-location="orgLocation" @sure="confirm"></orderList>

    </div>
</template>

<script>
    import backTitleBar from "@/components/titleBar/backTitleBar"
    import {qryShopWayInfoByShopId,openDoorForLocker} from "@/api/shop"
    import orderList from "./waitOrderList";
    import store from "../../store";
    import {getToken} from "@/utils/util"
    export default {
        name: "lockerCargoList",
        components:{backTitleBar,orderList},
        computed:{
            'usedWayList':function(){
                let array = []
                this.data.forEach(item=>{
                    if(item.isUse == '1'){
                        array.push(item)
                    }
                })
                return array
            },
            'noUsedWayList':function(){
                let array = []
                this.data.forEach(item=>{
                    if(item.isUse != '1'){
                        array.push(item)
                    }
                })
                return array
            },
        },
        data(){
            return{
                shopId:'',
                orgId:'',
                data:[],
                curShopZone:{},
                wayId:'',
                orgLocation:'',
                timer:null,
                time: 5,
                isOpening:false,
                tabActive:0,
                tabList:[],

            }
        },
        created() {
            this.shopId = this.$route.query.shopId;
            // this.shopId = '713334369481129984';
            this.getList();
        },
        methods:{
            getList(){
                let params = {
                    shopId: this.shopId
                }
                qryShopWayInfoByShopId(params).then(res=>{
                    this.tabList = res.data;
                    if(res.data.length != 0 && res.data[0].wayUseInfoQueryVoList.length != 0){
                        this.shopName = res.data[0].wayUseInfoQueryVoList[0].shopName;
                        this.orgId = res.data[0].wayUseInfoQueryVoList[0].orgId;
                        this.orgLocation = res.data[0].wayUseInfoQueryVoList[0].lng + "," + res.data[0].wayUseInfoQueryVoList[0].lat
                        this.$store.webTitle = this.shopName;
                        this.data = res.data[this.tabActive].wayUseInfoQueryVoList
                        this.curShopZone = res.data[this.tabActive].shopZone
                        document.title = this.shopName;
                    }
                })
            },
            //切换状态
            tabClick(name) {
                this.curShopZone = this.tabList[name].shopZone
                this.data = this.tabList[name].wayUseInfoQueryVoList
            },
            confirm(){

            },
            //开门或者查看关联订单操作
            doEvent(data){
                if(data.isUse == 1){
                    //查看关联订单
                    this.$router.push({name:'lockerOrderDetail',query:{wayId:data.wayId,canOperate:true}})
                }else{
                    //开门
                    if(this.isOpening){
                        return
                    }
                    let params = {
                        shopId: data.shopId,
                        wayId: data.wayId,
                        accessToken:getToken(),
                        operateType:0
                    }
                    let _this = this;
                    this.wayId = data.wayId;
                    this.isOpening = true;
                    openDoorForLocker(params).then(res=>{
                        this.isOpening = false;
                        if(res.code == 0){
                            this.$toast({
                                type: 'loading',
                                message: '正在开门中...',
                                mask: true,
                                duration: 0
                            })
                            this.time = 5;
                            this.timer = setInterval(function(){
                                _this.time -= 1;
                                if(_this.time <= 0){
                                    clearInterval(_this.timer);
                                    _this.$toast.clear();
                                    _this.timeOutCallback();
                                }
                            },1000)
                        }
                    })
                }
            },
            lockerOpenSuccessCallback(result){
                clearInterval(this.timer);
                this.$toast.clear();
                this.isOpening = false;
                console.log('successResult' ,result);
                //7000开门成功   7005开门失败
                if(result.response.code == 200 && result.response.extra.handleStatus == 7000){
                    this.$refs.orderList.shopZoneType = this.curShopZone.zoneType;
                    this.$refs.orderList.popupShow = true;
                }else{
                    this.$toast("开门失败，请重试");
                }
            },

            timeOutCallback(){
                this.isOpening = false;
                this.$dialog.alert({
                    title: "提示",
                    message: "请求超时，是否确定已开门成功？",
                    showCancelButton: true,
                    confirmButtonText:'已开门，绑定订单',
                    cancelButtonText:'取消'
                })
                    .then(() => {     //点击确认按钮后的调用
                        this.$refs.orderList.shopZoneType = this.curShopZone.zoneType;
                        this.$refs.orderList.popupShow = true;
                    })
                    .catch(() => { //点击取消按钮后的调用
                        console.log("cancel")
                    })
            }
        }

    }
</script>

<style scoped lang="scss">
    .page-list{
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
    }
    .list{
        display: flex;
        flex-wrap: wrap;
        .cargo-item{
            display: flex;
            flex-direction: column;
            justify-content: center;
            width: 2.2rem;
            height: 1.68rem;
            background: #fff;
            border-radius: .12rem;
            margin-top: .2rem;
            margin-right: .2rem;
            &:nth-child(3n){
                margin-right: 0;
            }
            .btn{
                width: 1.56rem;
                height: .56rem;
                line-height: .56rem;
                text-align: center;
                border-radius: .08rem;
                margin: .2rem auto 0;
                background: $main-color;
                color: #fff;
                position: relative;
                font-size: .28rem;
                .opc{
                    width:1.3rem;
                    height:.46rem;
                    background:$main-color;
                    border-radius:.08rem;
                    opacity:0.6;
                    filter:blur(.08rem);
                    position: absolute;
                    bottom: -.07rem;
                    left: .07rem;
                }
                .opc-in{
                    position: relative;
                    z-index: 10;
                }
            }
            &.active{
                .btn{
                    background:rgba(255,129,11,0.05);
                    color: $org;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// lockerCargoList.vue?b022ba32